import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth'

const serviceRoutes: Array<RouteRecordRaw> = [
  {
    path: '/:catchAll(.*)',
    name: 'not-found',
    component: () => import('@/views/ErrorPage/ErrorPage.vue'),
    meta: {
      layout: 'Main',
    },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/HomePage/HomePage.vue'),
    meta: {
      layout: 'Main',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/AuthPage/AuthPage.vue'),
    meta: {
      layout: 'Auth',
    },
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import('@/views/AuthPage/AuthPage.vue'),
    meta: {
      layout: 'Auth',
    },
  },
  {
    path: '/knowledge-base',
    name: 'base',
    component: () => import('@/views/ArticlesPage/ArticlesPage.vue'),
    meta: {
      layout: 'Main',
    },
  },
  {
    path: '/knowledge-base/:id',
    name: 'baseItem',
    component: () => import('@/views/ArticlePage/ArticlePage.vue'),
    meta: {
      layout: 'Main',
    },
  },
  {
    path: '/patient/:id',
    name: 'patient',
    component: () => import('@/views/PatientPage/PatientPage.vue'),
    meta: {
      layout: 'Main',
    },
  },
  {
    path: '/consultations',
    name: 'consultations',
    component: () => import('@/views/ConsultationPage/ConsultationPage.vue'),
    meta: {
      layout: 'Main',
    },
  },
  {
    path: '/eye-viewer',
    name: 'eye-viewer',
    component: () => import('@/views/EyeViewerPage/EyeViewerPage.vue'),
    meta: {
      layout: 'Main',
    },
  },
]

const landingRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'landingHome',
    component: () => import('@/views/landing/HomeView.vue'),
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: '/red-eye',
    name: 'red-eye',
    component: () => import('@/views/landing/RedEyeView.vue'),
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: '/retina',
    name: 'retina',
    component: () => import('@/views/landing/RetinaView.vue'),
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: '/dmo',
    name: 'dmo',
    component: () => import('@/views/landing/DmoView.vue'),
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: '/vmd',
    name: 'vmd',
    component: () => import('@/views/landing/VmdView.vue'),
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: '/rn',
    name: 'rn',
    component: () => import('@/views/landing/RnView.vue'),
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: '/glaucoma',
    name: 'glaucoma',
    component: () => import('@/views/landing/GlaucomaView.vue'),
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: '/myopia',
    name: 'myopia',
    component: () => import('@/views/landing/MyopiaView.vue'),
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: '/documents',
    name: 'documents',
    component: () => import('@/views/landing/DocumentsView.vue'),
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: '/documents/:id',
    name: 'document-detail',
    component: () => import('@/views/landing/DocumentDetailView.vue'),
    meta: {
      layout: 'Landing',
    },
  },
]

const routes = [...serviceRoutes, ...landingRoutes]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash)
      return { selector: to.hash }
    if (savedPosition)
      return savedPosition
    return { x: 0, top: 0 }
  },
  routes,
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  if (
    !authStore.isAuth
    && to.name !== 'login'
    && to.name !== 'registration'
    && to.name !== 'base'
    && to.name !== 'baseItem'
    && to.name !== 'not-found'
    && !(to.name as string).includes('pdf')
    && to.meta.layout !== 'Landing'
  ) {
    next({ name: 'login' })
  }
  else {
    next()
  }
})

export { router, routes }
